import { useEffect, useState } from "react";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";
import { VEHICLE_LABELS } from "@/lib/format";

export default function AdminVehicles() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    rpc("admin_get_vehicles").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  if (rows === null) return <Loader />;
  const columns = [
    { key: "plate", label: "Placa", render: (r) => <span className="font-mono font-semibold text-white">{r.plate || "—"}</span> },
    { key: "type", label: "Tipo", render: (r) => VEHICLE_LABELS[r.type] },
    { key: "brand", label: "Marca / Modelo", render: (r) => `${r.brand || ""} ${r.model || ""}`.trim() || "—" },
    { key: "color", label: "Color" },
    { key: "driver_name", label: "Conductor" },
    { key: "is_active", label: "Activo", render: (r) => (r.is_active ? "Sí" : "No") },
  ];
  return (
    <div>
      <PageHeader title="Vehículos" subtitle="Flota registrada por los conductores." testId="admin-vehicles" />
      <AdminTable columns={columns} rows={rows} testId="admin-vehicles-table" empty="No hay vehículos" />
    </div>
  );
}
